import { FiArrowLeft } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import Header from 'components/ui/Header';
import SearchInput from 'components/ui/inputs/SearchInput';

const OCRHeader = ({ onSearch }) => {
  const { t } = useTranslation();

  return (
    <Header>
      <div className="d-flex  align-items-center justify-content-between">
        <div className="d-flex align-items-center">
          <div>
            <h2 className="m-0 p-0 fw-lighter">OCR Templates</h2>
          </div>
        </div>

        <div style={{ minWidth: 400 }}>
          <SearchInput id="search-db" onSearch={onSearch} />
        </div>

        <div className="d-flex justify-content-end align-items-center">
          <Link className="btn btn-outline-light padding ms-3" to={`/ocr/add`}>
            {t('actions.add')}
          </Link>
        </div>
      </div>
    </Header>
  );
};

export default OCRHeader;
